import React from "react";

const RadioButton = (props) => {
	return (
		<div className="radio-button" onClick={props.onChange.bind(null, props.value)}>
			<input
				className="radio-button__input with-gap"
				name={props.name}
				type="radio"
				id={props.id}
				value={props.value}
				checked={props.checked}
				readOnly />

			<label
				className="radio-button__label"
				htmlFor={props.ids}>

			</label>

			{props.children}
		</div>
	);
};

//RadioButton.defaultProps = { onChange: () => null };

export default RadioButton;



// WEBPACK FOOTER //
// ./src/js/common/components/form/RadioButton.js